import { render, staticRenderFns } from "./tendencyChats.vue?vue&type=template&id=44c993b8&scoped=true"
import script from "./tendencyChats.vue?vue&type=script&lang=js"
export * from "./tendencyChats.vue?vue&type=script&lang=js"
import style0 from "./tendencyChats.vue?vue&type=style&index=0&id=44c993b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c993b8",
  null
  
)

export default component.exports